import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  fill: "none",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#667085",
      d: "M6.003 1.168v1.333h4V1.168h1.333v1.333h2.667c.368 0 .666.299.666.667v10.667a.667.667 0 0 1-.666.666h-12a.667.667 0 0 1-.667-.666V3.168c0-.368.298-.667.667-.667h2.666V1.168zm7.333 6.667H2.669v5.333h10.667zm-8.667-4h-2V6.5h10.667V3.835h-2v1.333h-1.333V3.835h-4v1.333H4.669z"
    }, null, -1)
  ]))]))
}
export default { render: render }